import React from "react";
import {withRouter} from "react-router-dom";
import {compose} from "recompose";
import {withAuthenticated} from "../../firebase/context";
import OfferForm from "./DataForm";
import OfferList from "./DataList";


class Dashboard extends React.Component {


    constructor(props) {
        super(props);
        this.state = {}
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    render() {
        return <div className="flex_row">
            <OfferList/>
            <OfferForm/>
        </div>
    }
}


export default compose(
    withRouter,
    withAuthenticated,
)(Dashboard);
